/* oxlint-disable react/exhaustive-deps */
import type { GenericThunkAction } from '@ms/yammer-data/dist/types';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Action } from 'redux';

type ActionCreator<T extends unknown[]> = (...args: T) => Action | GenericThunkAction<void>;
type UseDispatchActionCallback = <T extends unknown[]>(creator: ActionCreator<T>, ...args: T) => () => void;
export const useDispatchActionCallback: UseDispatchActionCallback = (creator, ...args) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(creator(...args));
    // eslint-disable-next-line react-hooks/use-memo
  }, [dispatch, creator, ...args]);
};
